import {Component, HostBinding, Inject, OnInit, TemplateRef} from '@angular/core';
import {DialogModule, DialogRef} from "@angular/cdk/dialog";
import {NgTemplateOutlet} from "@angular/common";
import {OverlayRef} from "@angular/cdk/overlay";
import {animate, style, transition, trigger} from "@angular/animations";

export interface DialogData {
  title: string;
  content: TemplateRef<any>;
  actions: TemplateRef<any>;
}

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
  imports: [DialogModule, NgTemplateOutlet],
  animations: [
    trigger('dialogAnimation', [
      transition(':enter', [
        style({opacity: 0}),
        animate('200ms ease-in', style({opacity: 1}))
      ]),
    ])
  ],
  standalone: true
})
export class DialogComponent {
  data!: DialogData;

  constructor(
    public dialogRef: DialogRef<string>,
    private overlayRef: OverlayRef
  ) {
  }

  close(result?: string): void {
      this.dialogRef.close(result);
      this.overlayRef.dispose();
  }

  onCloseClick(): void {
    this.close('Dialog closed by user');
  }
}
